import React from 'react';
import { SvgImage } from '../SvgImage';
import unspecifiedLoadVerticalSvg from '../../../../assets/icons/unspecified-load-vertical.svg';

export const UnknownApplication: React.FC<{ x: number; y: number }> = ({ x, y }) => {
  return <SvgImage key="icon" transforms={['scale(0.85)']} svgText={unspecifiedLoadVerticalSvg} x={x - 1} y={y - 2} />;
};
